var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			return $owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.slideshow = {
	initialized: false,
	init: function() {
		if ($('.category.slideshow').length === 0) {
			return null;
		}

		if (!site.slideshow.initialized) {
			site.slideshow.initialized = true;
			if ($('.item', '.category.slideshow').length > 1) {
				var $owl = site.owl.init('.category.slideshow .items', {
					loop: true,
					dots: false,
					nav: false,
					items: 1,
					navText: ["", ""],
					stopOnHover: true,
					autoplay: true,
					autoplayTimeout: 8000,
					autoplaySpeed:500,
					smartSpeed:500,
					autoplayHoverPause: true,
					animateOut: 'fadeOut',
					animateIn: 'fadeIn'
				});

				$('.controls .prev').on('click', function() {
					$owl.trigger('prev.owl.carousel');
				});

				$('.controls .next').on('click', function() {
					$owl.trigger('next.owl.carousel');
				});
			}
		}
	}
};

site.frontpage = {
	init: function() {
		$('a.scroll[href^=#]').on('click', function() {
			var target = $(this.hash);
			target = target.length ? target : $('[id=' + this.hash.slice(1) +']');
			if (target.length) {
				var offset = $('body').width() < 990 ? 62 : 0;
				$('html,body').animate({
					scrollTop: target.offset().top - offset
				}, 1000);
				return false;
			}
		});

		site.owl.init('.frontpage .box_aitems #ad-text ul', {
			loop: true,
			dots: true,
			dotsData: true,
			mouseDrag: true,
			touchDrag: true,
			margin: 20,
			nav: false,
			responsive: {
				0: {
					items: 1
				}
			},
			navText: ["", ""],
			stopOnHover: true,
			onInitialized: function() {
				$('.owl-dots').wrapAll('<div class="owl-dots-wrap" />')
			}

		});

		site.frontpage.tubeCarousel();
		$(window).resize(function() {
			site.frontpage.tubeCarousel();
		});
	},

	hasCarousel: false,
	owl: null,

	tubeCarousel: function() {
		var $body = $('body');
		if ($body.width() + 15 < 992 && $body.width() > 767) {
			if (!site.frontpage.hasCarousel) {
				site.frontpage.owl = site.owl.init('.tube__channel', {
					responsive: {
						0: {
							items: 1
						}
					}
				});
				site.frontpage.hasCarousel = true;
			}
		}
		else {
			if (site.frontpage.hasCarousel) {
				site.frontpage.owl.owlCarousel('destroy');
				$('.tube__channel').removeClass('owl-carousel');
				site.frontpage.hasCarousel = false;
			}
		}
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.megamenu.init();
	site.stickyHead.init();
	site.slideshow.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
